import { render, staticRenderFns } from "./attribute_value_list.vue?vue&type=template&id=967833ae&scoped=true"
import script from "./attribute_value_list.vue?vue&type=script&lang=js"
export * from "./attribute_value_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967833ae",
  null
  
)

export default component.exports